import React from "react";

const Link  = ({style = {}, size = "36", className = "", fill = "#73788B", viewBox = "0 0 36 36"}) => (
    <svg
        width={size}
        style={style}
        height={size}
        viewBox={viewBox}
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        className={`${className || ""}`}
        xmlnsXlink="http://www.w3.org/1999/xlink"
    >
      <path className="u_fill"
          d="M11.37 16.675c2.126-2.124 5.831-2.124 7.956 0l1.326 1.326 2.651-2.651-1.326-1.326a9.311 9.311 0 00-6.629-2.746c-2.505 0-4.86.976-6.629 2.746l-3.98 3.977c-3.652 3.654-3.652 9.604 0 13.258a9.345 9.345 0 006.63 2.74 9.343 9.343 0 006.63-2.74l1.327-1.326-2.652-2.651-1.326 1.326c-2.194 2.188-5.762 2.191-7.957 0a5.634 5.634 0 010-7.956l3.98-3.977z"
            fill={fill}
      />
      <path className="u_fill"
          d="M18 4.741l-1.326 1.326 2.652 2.651 1.326-1.325a5.64 5.64 0 017.957 0 5.634 5.634 0 010 7.955l-3.98 3.977c-2.125 2.124-5.83 2.124-7.955 0l-1.325-1.326-2.652 2.651 1.326 1.326a9.312 9.312 0 006.629 2.747c2.505 0 4.86-.977 6.629-2.747l3.98-3.977c3.652-3.654 3.652-9.603 0-13.258-3.658-3.656-9.608-3.654-13.26 0z"
            fill={fill}
      />
    </svg>
);

export default Link;
